export default __webpack_public_path__ + "static/media/hands.95317a78.webp";